<template lang="pug">
#member-auth-form.mobile-margin
  div(v-if="existing")
    div(v-if="!member.id")
      b-icon(icon="lock" size="is-large")
      p.is-size-5.msg {{ account.organization_short }} members only. Please enter your phone number.
      form(
        @submit.prevent="lookup"
      )
        b-field(grouped)
          phone-field(
            v-model="number"
            v-validate="'required'"
            placeholder="Phone number"
          )
          p.control
            button.button.is-primary(
              :class="{ 'is-loading': settings.submitting }"
              type="submit"
            ) Login
    div(v-else-if="!(member.is_approved && member.is_verified)")
      b-icon(icon="lock" size="is-large")
      div(v-if="member.is_verified")
        p.is-size-5.msg Thank you for verifying your phone number. We couldn&rsquo;t automatically confirm your {{ account.abbreviation }} membership status, but we will notify you after we review your request. If you have questions, please contact us at <a :href="`mailto:${account.email}`">{{account.email}}</a>.
      div(v-else)
        p.is-size-5.msg We sent you a text message with a verification code. Please enter it below to verify that this is your phone number.
        form(@submit.prevent="verify")
          b-field(grouped)
            b-input(
              v-model="key"
              v-validate="'required'"
              placeholder="Verification Code"
            )
            p.control
              button.button.is-primary(
                :class="{ 'is-loading': settings.submitting }"
                type="submit"
              ) Verify
  div(v-else)
    b-icon(icon="lock" size="is-large")
    p.is-size-5.msg We don&rsquo;t recognize your number. Please enter your name to request access.
    form.verify-form(@submit.prevent="request")
      b-field(grouped)
        b-input(
          v-model="name"
          v-validate="'required'"
          placeholder="Name"
        )
        phone-field(
          v-model="number"
          v-validate="'required'"
          placeholder="Phone number"
        )
        p.control
          button.button.is-primary(
            :class="{ 'is-loading': settings.submitting }"
            type="submit"
          ) Request Access
</template>

<script>
import { mapGetters } from 'vuex';
import PhoneField from '@/components/events/PhoneField.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'member-auth-form',
  components: {
    PhoneField,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      episode: getterTypes.GET_EPISODE,
      member: getterTypes.GET_MEMBER,
    }),
  },
  data() {
    return {
      key: null,
      existing: true,
      name: null,
      number: null,
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    async lookup() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        const formattedNumber = `+1${this.number.replace(/\D/g, '')}`;
        try {
          await this.$store.dispatch(actionTypes.DO_GET_MEMBER, {
            id: formattedNumber,
          });
        } catch (error) {
          this.existing = false;
        }
        this.settings.submitting = false;
      }
    },
    async request() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        await this.$store.dispatch(actionTypes.DO_CREATE_MEMBER, {
          name: this.name,
          phone_number: this.number,
          verify: true,
        });
        this.existing = true;
        this.settings.submitting = false;
      }
    },
    async verify() {
      const valid = await this.$validator.validateAll();
      if (valid) {
        this.settings.submitting = true;
        try {
          await this.$store.dispatch(actionTypes.DO_UPDATE_MEMBER, {
            id: this.key,
            verify: true,
          });
        } catch (e) {
          console.log(e);
        } finally {
          this.settings.submitting = false;
        }
      }
    },
  },
};
</script>

<style lang="scss">
#member-auth-form {
  color: $white;
  text-align: center;
  .msg {
    margin: 1.25rem 0 2rem 0;
  }
  .field {
    justify-content: center;
  }
}

@media (max-width: $tablet) {
  #member-auth-form {
    padding-top: 2rem;
    padding-bottom: 2rem;
    .verify-form {
      flex-flow: column;
      .control + .control {
        margin-top: 1rem;
      }
    }
  }
}
</style>
